import { useAto } from '../../../hooks/useAto/useAto';
import { useDefaultValueForFromTo } from '../../../features/providers/TaskCreationProvider/TaskCreationProvider';
import { useTaskCreationContext } from '../../../pages/TaskCreation';

export const useDefaultFrom = () => {
  const entity = useDefaultValueForFromTo();
  const { contact } = useTaskCreationContext();
  const ato = useAto();
  const isNonAbnEntity = !entity?.taxNumber;

  return isNonAbnEntity ? ato : contact ?? null;
};
